import { IroRiskCard_IroFragment } from '@/graphql/generated';
import { ColorIcon, ColorIconColor } from '@/components/generic/icon/ColorIcon';
import { IroName, IroNameProps } from './IroName';
import { WarningIcon } from '@/components/icons';

export function IroRiskCard({
  iro,
  language,
}: { iro: IroRiskCard_IroFragment } & IroNameProps) {
  return (
    <div className="bg-white p-2 rounded-lg border border-gray-100 shadow-sm">
      <div className="flex items-center gap-4">
        <div className="bg-green-50 rounded-lg p-1 text-green-900 shrink-0 w-8 h-8 flex items-center justify-center">
          <ColorIcon color={ColorIconColor.Yellow} icon={<WarningIcon />} />
        </div>
        <IroName {...{ iro, language }} />
      </div>
    </div>
  );
}
